/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-body[_ngcontent-%COMP%]{min-height:232px;max-height:calc(100vh - 220px);overflow-y:auto}"];
export { styles as styles };
